import { LastMessageText } from '@halo/ui-chat-react';
import { Box, Text } from '@chakra-ui/react';
import { useMsgMediaTitle } from '../msg-media-call';
import type { MsgMediaCallCancelledContentProps } from './msg-media-call-cancelled-content';
import { MsgMediaCallCancelledContent } from './msg-media-call-cancelled-content';

export interface MsgMediaCallCancelledPreviewProps extends MsgMediaCallCancelledContentProps {}

export const MsgMediaCallCancelledPreview = memo(function MsgMediaCallCancelledPreview({
  message,
}: MsgMediaCallCancelledPreviewProps) {
  const { type } = message.payload;

  const { title } = useMsgMediaTitle({ type });

  return (
    <LastMessageText>
      <Text as="span" color="fg.error" flexShrink={0}>
        {title}
      </Text>
      <Box as="span" truncate minW={0} flex={1}>
        <MsgMediaCallCancelledContent message={message} />
      </Box>
    </LastMessageText>
  );
});
